import { AuditActionType } from '@exam-management/graphql';

export function getAuditActionTypeText(actionType: AuditActionType): string {
  switch (actionType) {
    case AuditActionType.Add:
      return 'Add';
    case AuditActionType.Update:
      return 'Update';
    case AuditActionType.Delete:
      return 'Delete';
    case AuditActionType.Approve:
      return 'Approve';
    case AuditActionType.Reject:
      return 'Reject';
    case AuditActionType.Login:
      return 'Login';
    case AuditActionType.Logout:
      return 'Logout';
    case AuditActionType.AutoSync:
      return 'Auto Sync';
    case AuditActionType.ChangeStatus:
      return 'Change Status';
    case AuditActionType.Create:
      return 'Create';
    case AuditActionType.Download:
      return 'Download';
    case AuditActionType.Export:
      return 'Export';
    case AuditActionType.Grant:
      return 'Grant';
    case AuditActionType.Import:
      return 'Import';
    case AuditActionType.Remove:
      return 'Remove';
    case AuditActionType.Submit:
      return 'Submit';
    case AuditActionType.View:
      return 'View';
    case AuditActionType.Revoke:
      return 'Revoke';
    case AuditActionType.SendResultToWr:
      return 'Send Result to Web Register';
    case AuditActionType.Upload:
      return 'Upload';
    case AuditActionType.Disable:
      return 'Disable';
    default:
      return 'Unknown Action';
  }
}
